import { render, staticRenderFns } from "./message-details-to-block.vue?vue&type=template&id=2c506136&scoped=true"
import script from "./message-details-to-block.vue?vue&type=script&lang=js"
export * from "./message-details-to-block.vue?vue&type=script&lang=js"
import style0 from "./message-details-to-block.vue?vue&type=style&index=0&id=2c506136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c506136",
  null
  
)

export default component.exports